module.exports = __webpack_public_path__ + "img/key-white-l.b9a628b2.svg";